import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableColumnWidth } from 'projects/bis-shared/src/lib/datatable/datatable-column-width';
import { DatatableComponent } from 'projects/bis-shared/src/lib/datatable/datatable/datatable.component';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import * as moment from 'moment-timezone';
import { DialogService } from 'projects/bis-shared/src/lib/dialog/dialog.service';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { AssigneeModalComponent } from '../assignee-modal/assignee-modal.component';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { SnackbarService } from 'projects/bis-shared/src/lib/snackbar/snackbar.service';
import { PriorAuthWorkRequestService } from '../prior-auth-work-request.service';
import { ObjectTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { Moment } from 'moment-timezone';
import { FilterDataType } from 'projects/bis-shared/src/lib/datatable/datatable-filter/filter-operations';

@Component({
  selector: 'app-active-prior-auth-list-insurer-my-org-component',
  templateUrl: './active-prior-auth-list-insurer-my-org.component.html',
  styleUrls: ['./active-prior-auth-list-insurer-my-org.component.scss'],
})
export class ActivePriorAuthListInsurerMyOrgComponent implements OnInit {
  @ViewChild(DatatableComponent) datatableComponent: DatatableComponent;
  @ViewChild('idTemplate', { static: true }) idTemplate: TemplateRef<any>;
  @ViewChild('injuryDateTemplate', { static: true }) injuryDateTemplate: TemplateRef<any>;
  columns: DatatableColumn[];
  filterColumn: string[];
  dataUrl: string;
  defaultSort: DatatableSort[];
  aggregatedData: any[];
  AppUrls = AppUrls;
  filteredProvider: string = '';
  lastLoginDate: Moment = this.identityService.apiToken.lastLoginDateTime;
  isWorkloadAdministrator: boolean;
  isDataTableReady: boolean = false;
  priorAuthTypeCode = ObjectTypeCode.PriorAuthorization;
  numRowsSelected: number = 0;

  constructor(
    private priorAuthWorkRequestService: PriorAuthWorkRequestService,
    private identityService: IdentityService,
    private externalApiUrls: ExternalApiUrls,
    private snackbarService: SnackbarService,
    private dialogService: DialogService,
  ) {
    this.defaultSort = [
      {
        property: 'assignedOrderBy',
        sortAscending: true,
      },
      {
        property: 'dueDate',
        sortAscending: true,
      },
    ];
  }

  ngOnInit() {
    this.priorAuthWorkRequestService.getWorkloadAdminStatus().subscribe(result => {
      this.isWorkloadAdministrator = result;
      if (this.isWorkloadAdministrator) {
        const checkbox = {
          title: '',
          property: 'checkbox',
          template: DatatableStaticTemplateType.CheckboxTemplate,
          disableSorting: true,
          filterDataType: FilterDataType.None,
        };
        this.columns = [checkbox, ...this.columns];
      }
      this.isDataTableReady = true;
    });
    this.setColumns();
    this.dataUrl = this.externalApiUrls.priorAuthorization.priorAuthorizationWorkRequestForInsurers();
  }

  setColumns() {
    this.columns = [
      {
        title: 'PAR ID',
        property: 'priorAuthorizationId',
        filterDataType: FilterDataType.SystemId,
        filterSystemIdFixedTypeCode: ObjectTypeCode.PriorAuthorization,
        template: this.idTemplate,
        width: 150,
      },
      {
        title: 'Type',
        property: 'priorAuthorizationRequestType',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'Due Date',
        property: 'dueDate',
        filterDataType: FilterDataType.DateTime,
        template: DatatableStaticTemplateType.EasternDateTemplate,
        width: DatatableColumnWidth.medium,
      },
      {
        title: 'PAR Status',
        property: 'priorAuthStatus',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'RFI',
        property: 'latestRFIState',
        filterDataType: FilterDataType.Reference,
        titleToolTip: 'Request for Further Information from Provider',
        width: DatatableColumnWidth.small,
      },
      {
        title: 'Patient',
        property: 'patient',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'Claim Admin Claim #',
        property: 'carrierCaseNumber',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'WCB Case #',
        property: 'wcbCaseNumber',
        filterDataType: FilterDataType.String,
        template: DatatableStaticTemplateType.CaseNumberTemplate,
        width: DatatableColumnWidth.large,
      },
      {
        title: 'Injury Date',
        property: 'dateOfInjury',
        filterDataType: FilterDataType.Date,
        width: DatatableColumnWidth.medium,
        template: this.injuryDateTemplate,
      },
      {
        title: 'Assigned Organization',
        property: 'assignedOrganization',
        filterDataType: FilterDataType.String,
      },
      { title: 'Assigned User', property: 'assignedUser', filterDataType: FilterDataType.String },
      { title: 'Claim Admin', property: 'claimAdminName', filterDataType: FilterDataType.String },
      {
        title: 'Employer Name',
        property: 'employerName',
        filterDataType: FilterDataType.String,
      },
      { title: 'Insurer', property: 'insurerName', filterDataType: FilterDataType.String },
      { title: 'Provider', property: 'provider', filterDataType: FilterDataType.String },
      {
        title: 'Current Activity',
        property: 'workRequestName',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'PAR Status Date',
        property: 'priorAuthStatusDate',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.EasternDateTimeHMSTemplate,
      },
      {
        title: 'DOB',
        property: 'dateOfBirth',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.UtcDateTemplate,
      },
      {
        title: 'Medication',
        property: 'medicationRequested',
        filterDataType: FilterDataType.String,
      },
    ];
  }

  selectedWorkRequestsInSameSenderOrganization(
    workRequests: any,
  ): { value: boolean; errorMessage: string } {
    const associatedEntities = workRequests.map(({ senderEntityTypeCode, senderEntityId }) => ({
      senderEntityTypeCode,
      senderEntityId,
    }));
    const associatedEntitiesExpectedLength = associatedEntities.length; //All selected work requests should have the same Entity ID/Entity type code combo(PBM,UR,Senders only)
    const firstEntityPair = associatedEntities[0];

    const associatedEntitiesActualLength = associatedEntities.filter(
      entity =>
        entity.senderEntityTypeCode === firstEntityPair.senderEntityTypeCode &&
        entity.senderEntityId === firstEntityPair.senderEntityId &&
        entity.medicalReviewerId === firstEntityPair.medicalReviewerId,
    ).length;

    const workRequestsAssociatedWithSender =
      firstEntityPair.senderEntityTypeCode === EntityTypeCode.ThirdPartyAdministrator ||
      firstEntityPair.senderEntityTypeCode === EntityTypeCode.Insurer;

    let errorMsg = '';

    if (
      associatedEntitiesExpectedLength === associatedEntitiesActualLength &&
      workRequestsAssociatedWithSender
    ) {
      return { value: true, errorMessage: errorMsg };
    } else {
      if (
        !workRequestsAssociatedWithSender &&
        associatedEntitiesExpectedLength !== associatedEntitiesActualLength
      ) {
        errorMsg =
          "The item(s) you've selected are not assigned to a claim administrator. Also, the items you've selected belong to different Claim Administrators. Please select items form the same Claim Administrator in order to assign.";
      } else if (!workRequestsAssociatedWithSender) {
        errorMsg = "The item(s) you've selected are not assigned to a claim administrator";
      } else {
        errorMsg =
          "The items you've selected belong to different Claim Administrators. Please select items form the same Claim Administrator in order to assign.";
      }
      return { value: false, errorMessage: errorMsg };
    }
  }

  selectedWorkRequestsInSamePriorAuthStatus(
    workRequests: any,
  ): { value: boolean; errorMessage: string } {
    const associatedPriorAuthStatuses = workRequests.map(wr => wr.priorAuthStatus);
    const firstPriorAuthStatus = associatedPriorAuthStatuses[0];
    const expectedStausesMatchLength = workRequests.length;
    const actualStatusesMatchLength = associatedPriorAuthStatuses.filter(
      status => status === firstPriorAuthStatus,
    ).length;
    let errorMsg = '';

    if (expectedStausesMatchLength === actualStatusesMatchLength) {
      return { value: true, errorMessage: errorMsg };
    } else {
      errorMsg =
        "The items you've selected are in different statuses. Please select items in the same status in order to assign.";
      return { value: false, errorMessage: errorMsg };
    }
  }

  selectedWorkRequestsInSameParType(workRequests: any): { value: boolean; errorMessage: string } {
    const associatedPriorAuthTypes = workRequests.map(wr => wr.priorAuthorizationRequestType);
    const firstPriorAuthType = associatedPriorAuthTypes[0];
    const expectedTypesMatchLength = workRequests.length;
    const actualTypesMatchLength = associatedPriorAuthTypes.filter(
      status => status === firstPriorAuthType,
    ).length;
    let errorMsg = '';

    if (expectedTypesMatchLength === actualTypesMatchLength) {
      return { value: true, errorMessage: errorMsg };
    } else {
      errorMsg =
        "The items you've selected are different PAR Types. Please select items of the same PAR Type in order to assign.";
      return { value: false, errorMessage: errorMsg };
    }
  }

  openAssignPriorAuthModal(selected) {
    const selectedIds = [];
    for (let sel = 0; sel < selected.length; sel++) {
      selectedIds.push(selected[sel].priorAuthorizationId);
    }

    const inSameSenderOrg = this.selectedWorkRequestsInSameSenderOrganization(selected);
    const inSamePriorAuthStatus = this.selectedWorkRequestsInSamePriorAuthStatus(selected);
    const inSameParType = this.selectedWorkRequestsInSameParType(selected);

    if (inSameSenderOrg.value && inSamePriorAuthStatus.value && inSameParType.value) {
      const data = {
        priorAuthWorkRequests: selected,
        title: 'Assign',
        message: 'Assign work to Reviewer',
      };
      this.dialogService.showCustomDialog(AssigneeModalComponent, data).subscribe(result => {
        if (result) {
          this.datatableComponent.reloadTable();
        }
      });
    } else {
      this.snackbarService.openSnackBarFailure(
        inSameSenderOrg.errorMessage +
          ' ' +
          inSamePriorAuthStatus.errorMessage +
          ' ' +
          inSameParType.errorMessage,
      );
    }
  }

  onRowSelected() {
    this.numRowsSelected = this.datatableComponent.selection.length;
  }

  getRowClass = (row: any) => {
    if (
      moment(row.workRequestUpdateDate).isAfter(this.lastLoginDate) ||
      moment(row.latestRFIStateDT).isAfter(this.lastLoginDate)
    ) {
      return 'row-highlight';
    } else {
      return '';
    }
  };
}
